export enum AppRoute {
  LANDING = '/',
  MAINTENANCE = '/maintenance',
  // This path must not be change for the time being due to Registria sending QRR and PRR redirects to this path.
  APPLIANCE_DETAILS = '/appliance-details',
  MODEL_SERIAL = '/model-serial',
  PURCHASE_PRICE = '/purchase-price',
  ARRIVAL_DATE = '/arrival-date',
  PERSONAL_DETAILS = '/personal-details',
  QUOTE = '/quote',
  CHECKOUT = '/checkout',
  CONFIRMATION = '/confirmation',
  ERROR = '/error',
}
